import React, {ButtonHTMLAttributes} from 'react';
import {twMerge} from 'tailwind-merge';

import './animation.css';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    colors?: string[];
}

export const GradientShadowButton: React.FC<React.PropsWithChildren<Props>> = ({
    className,
    colors = ['#FF7670', '#FFF06F', '#007cf0', '#ff0080', '#FF7670'],
    children,
    ...props
}: Props) => {
    return (
        <button
            className={twMerge(
                'relative inline-flex h-16 w-96 flex-col items-center justify-center rounded-lg bg-black',
                className
            )}
            {...props}
        >
            <span
                className={`gradientShadowButton absolute inset-px rounded-lg bg-[length:400%_100%]`}
                style={{backgroundImage: `linear-gradient(-90deg,${colors.join(',')})`}}
            />
            <span className="absolute inset-0 flex items-center justify-center rounded-lg bg-black font-['Inter'] text-xl font-bold text-white">
                {children}
            </span>
        </button>
    );
};
